import React, { useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import AppContext from '../../context/AppContext';
import styles from './Courses.module.css';
import coursesHero from '../../assets/images/gallery_3.jpg';
import airHostessImg from '../../assets/images/Air Hostess Training.png';
import airportMgmtImg from '../../assets/images/Airport Management.png';
import customerServiceImg from '../../assets/images/Customer Service Executive.png';

const COURSES = [
  {
    code: 'AH', name: 'Air Hostess Training', duration: '12 Months', eligibility: '12th Passed', seats: '30 Students',
    badge: 'Most Popular', image: airHostessImg, featured: true,
    desc: 'Our comprehensive Air Hostess Training program prepares you for an exciting career in the skies. This course covers all aspects of cabin crew responsibilities, from passenger safety to premium in-flight service. You will learn grooming standards, communication skills, emergency procedures, and cultural sensitivity required to excel in international aviation.',
    learn: ['Aviation Safety & Emergency Procedures', 'In-Flight Service Excellence', 'Personality Development & Grooming', 'Communication & Language Skills', 'First Aid & Medical Training', 'Cultural Awareness & Etiquette'],
    salary: ['₹25,000 - ₹35,000 Starting (India)', '₹50,000 - ₹1,00,000+ Experienced', '$2,000 - $5,000+ International'],
    career: ['Cabin Crew with Domestic Airlines', 'International Flight Attendant', 'VIP/Private Jet Cabin Crew']
  },
  {
    code: 'AM', name: 'Airport Management', duration: '12 Months', eligibility: '12th Passed', seats: '30 Students',
    badge: 'High Demand', image: airportMgmtImg, featured: false,
    desc: 'The Airport Management course equips you with the knowledge and skills required to manage airport operations efficiently. From ground handling to passenger services, security protocols to cargo management, this program covers the entire spectrum of airport administration. Our curriculum is designed in collaboration with airport authorities to ensure industry relevance.',
    learn: ['Airport Operations Management', 'Ground Handling Procedures', 'Passenger Handling & Check-in', 'Cargo & Baggage Management', 'Airport Security Protocols', 'Airline-Airport Coordination'],
    salary: ['₹20,000 - ₹30,000 Starting (India)', '₹40,000 - ₹80,000+ Experienced', '$1,500 - $4,000+ International'],
    career: ['Airport Operations Executive', 'Ground Staff Supervisor', 'Passenger Service Agent']
  },
  {
    code: 'CS', name: 'Customer Service Executive', duration: '12 Months', eligibility: '12th Passed', seats: '30 Students',
    badge: 'Foundation Course', image: customerServiceImg, featured: false,
    desc: 'Our Customer Service Executive program focuses on developing exceptional interpersonal and communication skills essential for the service industry. This course is perfect for those looking to start their career in aviation hospitality, retail, or any customer-facing role. Learn conflict resolution, complaint handling, and service excellence from industry experts.',
    learn: ['Effective Communication Skills', 'Customer Relationship Management', 'Conflict Resolution Techniques', 'Telephone & Email Etiquette', 'Sales & Upselling Skills', 'Stress Management'],
    salary: ['₹18,000 - ₹25,000 Starting (India)', '₹30,000 - ₹50,000+ Experienced', '$1,200 - $3,000+ International'],
    career: ['Customer Service Executive', 'Guest Relations Associate', 'Front Desk Officer']
  }
];

const TABLE_ROWS = [
  { feat: 'Duration', vals: ['12 Months', '12 Months', '12 Months'] },
  { feat: 'Eligibility', vals: ['12th Passed', '12th Passed', '12th Passed'] },
  { feat: 'Starting Salary', vals: ['₹25,000 - ₹35,000', '₹20,000 - ₹30,000', '₹18,000 - ₹25,000'] },
  { feat: 'Placement Rate', vals: ['98%', '95%', '92%'] }
];

const STUDENT_PROVISIONS = [
  {
    title: 'Training & Education',
    icon: '🎓',
    wide: true,
    items: [
      'Professional Cabin Crew Training',
      'Aviation Management Classes',
      'Airport Ground Handling Training',
      'Customer Service Training',
      'Communication & Personality Dev.',
      'Grooming & Personality Dev.',
      'Interview Preparation',
      'Body Language & Confidence',
      'English Communication Training'
    ]
  },
  {
    title: 'Study Material',
    icon: '📚',
    items: [
      'Printed Study Notes',
      'Aviation Training Modules',
      'Practical Airport Training'
    ]
  },
  {
    title: 'Certification',
    icon: '📜',
    items: [
      'University Approved Certificate',
      'NSDC (Govt. of India) Training Certificate'
    ]
  },
  {
    title: 'Placement Support',
    icon: '💼',
    items: [
      '100% Placement Assistance***',
      'Airlines/Airport Interview Skills**',
      'Professional Resume Preparation',
      'Mock Interview Training'
    ]
  },
  {
    title: 'Welcome Kit',
    icon: '🎁',
    items: [
      'Welcome Letter & Rules Handbook',
      'ID Card & Bonafide Certificate',
      'Student Uniform & Shoes (1 Pair)',
      'Hair Style & Makeup Training'
    ]
  }
];

const Courses = () => {
  const [activeFilter] = useState('ALL');
  const { openEnquiry } = useContext(AppContext);

  const filteredCourses = COURSES.filter(c => {
    if (activeFilter === 'ALL') return true;
    return true;
  });

  return (
    <main>
      {/* Hero */}
      <section className="page-hero" data-theme="dark">
        <img src={coursesHero} alt="Aviation Courses" style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover', zIndex: 0 }} />
        <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', background: 'linear-gradient(to right, rgba(0,0,0,0.7), rgba(0,0,0,0.3))', zIndex: 0 }} />
        <div className="container page-hero__content">
          <p className="page-hero__breadcrumb">HOME / COURSES</p>
          <h1 className="page-hero__title">
            <span className="page-hero__title-top" style={{ color: '#FFFFFF', opacity: 1 }}>AVIATION</span>
            <span className="page-hero__title-bottom" style={{ color: 'var(--cyan)' }}>COURSES.</span>
          </h1>
          <p className="page-hero__sub">
            Choose your aviation path - industry-recognized courses designed to launch your career
          </p>
        </div>
      </section>

      {/* Course Listing */}
      <section className={`section-py ${styles.listing}`}>
        <div className="container">
          {filteredCourses.map((c, i) => (
            <div key={c.code} className={`${styles.listCard} ${c.featured ? styles.listFeatured : ''} reveal`}>
              <div className={styles.listLeft} style={{ background: c.featured ? 'linear-gradient(135deg,#1558C0,#1A73E8)' : 'linear-gradient(135deg,#C8DCF5,#A0C0EC)', position: 'relative', overflow: 'hidden' }}>
                {c.image && <img src={c.image} alt={c.name} style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover', zIndex: 0 }} />}
                <span className={styles.listCode} style={{ zIndex: 1, position: 'relative' }}>{c.code}</span>
                {!c.image && <div className={styles.listIcon} style={{ fontSize: '4rem', zIndex: 1, position: 'relative' }}>{c.icon}</div>}
                <span className={styles.listDuration} style={{ zIndex: 1, position: 'relative' }}>{c.duration}</span>
              </div>
              <div className={styles.listRight}>
                <div className={styles.listTitleRow}>
                  <h2 className={styles.listTitle}>{c.name}</h2>
                  <span className="badge badge-filled-cyan">{c.badge}</span>
                </div>
                <p className={styles.listDesc}>{c.desc}</p>
                <div className={styles.listGrid}>
                  <div className={styles.listCell}>
                    <span className={styles.listCellLabel}>Eligibility</span>
                    <span className={styles.listCellVal}>{c.eligibility}</span>
                  </div>
                  <div className={styles.listCell}>
                    <span className={styles.listCellLabel}>Duration</span>
                    <span className={styles.listCellVal}>{c.duration}</span>
                  </div>
                  <div className={styles.listCell}>
                    <span className={styles.listCellLabel}>Seats</span>
                    <span className={styles.listCellVal}>{c.seats}</span>
                  </div>
                </div>
                <div style={{ marginTop: '2rem' }}>
                  <h4 style={{ marginBottom: '1rem', color: 'var(--text-main)' }}>Course Highlights:</h4>
                  <ul className={styles.learnList}>
                    {c.learn.map(l => <li key={l} className={styles.learnItem}><span className={styles.learnCheck}>✓</span>{l}</li>)}
                  </ul>
                </div>

                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '2rem', marginTop: '1.5rem', marginBottom: '1.5rem' }}>
                  <div>
                    <h4 style={{ marginBottom: '0.5rem', color: 'var(--text-main)', fontSize: '0.9rem' }}>Salary Expectations:</h4>
                    <ul style={{ listStyleType: 'disc', color: 'var(--text-muted)', fontSize: '0.85rem', paddingLeft: '1rem', display: 'flex', flexDirection: 'column', gap: '0.2rem' }}>
                      {c.salary.map(s => <li key={s}>{s}</li>)}
                    </ul>
                  </div>
                  <div>
                    <h4 style={{ marginBottom: '0.5rem', color: 'var(--text-main)', fontSize: '0.9rem' }}>Career Opportunities:</h4>
                    <ul style={{ listStyleType: 'disc', color: 'var(--text-muted)', fontSize: '0.85rem', paddingLeft: '1rem', display: 'flex', flexDirection: 'column', gap: '0.2rem' }}>
                      {c.career.map(career => <li key={career}>{career}</li>)}
                    </ul>
                  </div>
                </div>

                <div className={styles.listCtaRow}>
                  <button onClick={openEnquiry} className="btn-primary" style={{ height: 44, fontSize: 11 }}>Apply for This Course →</button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* ── NEW: STUDENT PROVISIONS SECTION ── */}
      <section className={styles.provisionsSection}>
        <div className="container">
          <div className="section-header reveal" style={{ textAlign: 'center' }}>
            <p className="label">STUDENT BENEFITS</p>
            <h2 className="section-title">What We Provide <span className="accent">To Students.</span></h2>
            <p className="page-hero__sub" style={{ margin: '1rem auto', maxWidth: 800 }}>Comprehensive support, world-class training materials, and guaranteed career placement assistance</p>
          </div>

          <div className={styles.provisionGrid}>
            {STUDENT_PROVISIONS.map((p, i) => (
              <div key={p.title} className={`${styles.provisionCard} ${p.wide ? styles.provisionCardWide : ''} reveal reveal-delay-${i + 1}`}>
                <span className={styles.pIcon}>{p.icon}</span>
                <h3 className={styles.pTitle}>{p.title}</h3>
                <ul className={`${styles.pList} ${p.wide ? styles.pListTwoCols : ''}`}>
                  {p.items.map(item => (
                    <li key={item} className={styles.pItem}>
                      <span className={styles.pCheck}>✓</span> {item}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className={`${styles.policySection} reveal`}>
            <div>
              <h4 className={styles.policyTitle}>💳 Fees Payment Methods:</h4>
              <div className={styles.paymentList}>
                {['Cash', 'Cheque', 'DD (Demand Draft)', 'RTGS / NEFT'].map(p => (
                  <span key={p} className={styles.paymentTag}>{p}</span>
                ))}
              </div>
            </div>
            <div>
              <h4 className={styles.policyTitle}>📌 Important Notes & Academy Policies:</h4>
              <div className={styles.notesList}>
                <div className={styles.noteItem}>Academies will Not Provide Gym/Swimming Class.</div>
                <div className={`${styles.noteItem} ${styles.noteCritical}`}>Fees once paid are non-refundable & non-adjustable.</div>
                <div className={styles.noteItem}>Students must pay fees timely per the schedule.</div>
                <div className={styles.noteItem}>Industrial visits/external training carry separate charges.</div>
                <div className={`${styles.noteItem} ${styles.noteCritical}`}>**Academy will not provide Transport, Food & Accommodation**</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Eligibility Criteria Section */}
      <section className={`section-py ${styles.eligibilitySection}`} style={{ background: 'var(--bg-secondary)' }}>
        <div className="container">
          <div className="section-header reveal" style={{ textAlign: 'center' }}>
            <p className="label">REQUIREMENTS</p>
            <h2 className="section-title">Eligibility <span className="accent">Criteria.</span></h2>
            <div className="label-rule" style={{ margin: '15px auto 30px' }} />
          </div>

          <div className={styles.criteriaGrid}>
            <div className={`${styles.criteriaCard} reveal`}>
              <div className={styles.criteriaIcon}>📝</div>
              <h3>Entrance Exam</h3>
              <p>NEET / CET PCM-based entrance exam including English, Basic Mathematics, General Knowledge, and IQ Test. <strong>Minimum 60% marks required.</strong></p>
            </div>
            <div className={`${styles.criteriaCard} reveal`}>
              <div className={styles.criteriaIcon}>📅</div>
              <h3>Age Limit</h3>
              <p>Applicants must be between <strong>17 to 26 years</strong> of age at the time of admission.</p>
            </div>
            <div className={`${styles.criteriaCard} reveal`}>
              <div className={styles.criteriaIcon}>🏥</div>
              <h3>Medical Test</h3>
              <p>Eye vision, skin clarity, height-weight ratio, and government-authorized MBBS doctor fitness certificate required.</p>
            </div>
            <div className={`${styles.criteriaCard} reveal`}>
              <div className={styles.criteriaIcon}>📏</div>
              <h3>Height Requirement</h3>
              <p><strong>Male:</strong> 165 to 170 cm<br /><strong>Female:</strong> 158 to 160 cm</p>
            </div>
            <div className={`${styles.criteriaCard} ${styles.criteriaCardWide} reveal`}>
              <div className={styles.criteriaIcon}>🎓</div>
              <h3>Educational Qualification</h3>
              <p>12th (Arts / Commerce / Science) with a <strong>minimum of 45% marks</strong> from a recognized board.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Comparison Table */}
      <section className={`section-py ${styles.comparison}`}>
        <div className="container">
          <p className="label reveal">COMPARE</p>
          <h2 className="section-title reveal" style={{ marginTop: 12, marginBottom: 40 }}>Course <span className="accent">Comparison.</span></h2>
          <p className="page-hero__sub reveal" style={{ marginBottom: '2rem', textAlign: 'center' }}>Compare our courses to find the perfect fit for your career goals</p>
          <div className={styles.tableWrap}>
            <table className={styles.table}>
              <thead>
                <tr className={styles.tableHead}>
                  <th>Feature</th>
                  <th>Air Hostess</th>
                  <th>Airport Management</th>
                  <th>Customer Service</th>
                </tr>
              </thead>
              <tbody>
                {TABLE_ROWS.map((r, i) => (
                  <tr key={r.feat} className={i % 2 === 0 ? styles.tableRowAlt : ''}>
                    <td className={styles.tableFeat}>{r.feat}</td>
                    {r.vals.map((v, j) => <td key={j} className={styles.tableVal}>{v}</td>)}
                  </tr>
                ))}
                <tr>
                  <td className={styles.tableFeat}>Action</td>
                  <td className={styles.tableVal}><button onClick={openEnquiry} style={{ color: 'var(--blue)', fontWeight: 'bold' }}>Apply Now</button></td>
                  <td className={styles.tableVal}><button onClick={openEnquiry} style={{ color: 'var(--blue)', fontWeight: 'bold' }}>Apply Now</button></td>
                  <td className={styles.tableVal}><button onClick={openEnquiry} style={{ color: 'var(--blue)', fontWeight: 'bold' }}>Apply Now</button></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* CTA SECTION */}
      <section className={styles.ctaBanner} style={{ background: 'var(--blue)', padding: '5rem 0', textAlign: 'center' }}>
        <div className="container" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <h2 style={{ color: 'white', fontSize: '2.5rem', marginBottom: '1rem' }}>Not Sure Which Course is Right for You?</h2>
          <p style={{ color: 'rgba(255,255,255,0.8)', fontSize: '1.1rem', maxWidth: '700px', marginBottom: '2rem' }}>Our career counselors are here to help you choose the perfect course based on your interests, qualifications, and career goals.</p>
          <div className={styles.ctaBtns}>
            <Link to="/contact" className={styles.btnWhite}>BOOK FREE COUNSELLING</Link>
            <Link to="/contact" className={styles.btnOutline}>CALL US NOW</Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Courses;
